<template lang="pug">
.box(:class="`box-${boxStyle}`" @click="$emit('click')")
  .box-content
    .box-container
      .box-title {{ title }}
      .box-body
        .box-value {{ value }}
    .box-icon(v-if="icon")
      i(:class="icon")
  .box-more
    slot
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], required: true },
    boxStyle: { type: String, default: () => 'primary' },
    icon: String,
  },
}
</script>

<style lang="stylus" scoped>
@import '../../styles/_colors.styl'

box-color(color)
  border-left-color color
  .box-container
    .box-title
      color color

.box
  cursor pointer
  border 1px solid #f1f1f1
  box-shadow 0 0.25rem 1rem rgba(48, 55, 66, .15)
  border-radius .35rem
  border-left .22rem solid
  padding 15px 20px
  overflow hidden
  background-color #fff
  height 100%
  transition ease .2s

  .box-content
    min-height 2rem
    display flex
    align-items center

  .box-container
    flex 1
    .box-title
      text-transform uppercase
      font-size .6rem
      font-weight 700

    .box-body
      line-height 1rem
      .box-value
        font-size 1.1rem
        font-weight 500
        color #5a5c69
  .box-icon
    i
      transition linear .2s
      font-size 1.8rem
      color #bdc3c7
  &:hover
    margin-top -5px
    margin-bottom 5px
    .box-icon
      i
        font-size 1.95rem

  &.box-primary
    box-color primary

  &.box-secondary
    box-color lighten(primary, 5%)

  &.box-danger
    box-color danger

  &.box-warning
    box-color warning

  &.box-success
    box-color success
</style>
